export class OAuthState {
  /**
   * @var Object
   */
  oAuthParams;
}
